module.exports = __webpack_public_path__ + "img/JAOC_POP_CheddarCheese_oval.98d1daa6.png";